module.exports = __webpack_public_path__ + "media/images/scroll-right-0c791580.svg";